import { IEtfCorrelationBackend, IEtfCorrelationMapBackend } from "./correlations.model";

const apiBaseUrl = process.env.REACT_APP_INTEGRATION_CORRELATIONS_URIBASE!;

export interface IEtfCorrelationService {
	correlations(ticker: string, currency: string): Promise<IEtfCorrelationBackend[]>;
	map(currency: string, mode: string): Promise<IEtfCorrelationMapBackend>;
}

export class EtfCorrelationServiceImpl implements IEtfCorrelationService {
	async correlations(ticker: string, currency: string): Promise<IEtfCorrelationBackend[]> {
		const response = await fetch(`${apiBaseUrl}/info/${ticker}?currency=${currency}`);
		const responseJson = await response.json();

		responseJson.entries.forEach((entry: any) => {
			if (typeof entry.firstDate === "string"){
				entry.firstDate = new Date(Date.parse(entry.firstDate))
			}
		});

		return responseJson.entries;
	}
	async map(currency: string, mode: string): Promise<IEtfCorrelationMapBackend> {
		const response = await fetch(`${apiBaseUrl}/map?currency=${currency}&mode=${mode}`);
		const responseJson = await response.json();
		return responseJson;
	}
}